var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"next btn text-wrap",class:{
        loading: _vm.loading,
        primary: _vm.type === 'primary',
        'btn-outline-default': _vm.type === 'outline',
        'btn-default': _vm.type === 'default',
    },attrs:{"disabled":_vm.loading || _vm.disabled},on:{"click":_vm.onClick}},[(_vm.loading)?_c('loader',{staticClass:"loader",attrs:{"size":"20px","color":_vm.type === 'outline' ? '#F45E85' : '#30d9c4'}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }